import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import { useModal } from "../../hooks/useModal";
import axios from "axios"
import config from "../../config"

// components
import InputComponent from "../partner/components/inputComponent";
import InputSelect from "../partner/components/inputSelect";
import { CircularProgress } from "@material-ui/core";
import InputDecimalInventory from "./components/inputDecimal";
import InputProfitProduct from "./components/inputProfitProduct";
import InputDisableSimpleText from "../user/components/inputDisableSimpleText";
import Modal from "../modals/Modal";
import PageTitle from "../../components/PageTitle/PageTitle";
//import ModalCamera from "../modals/ModalCamera";
import SwitchOwnProduct from "./components/switch";

export default function AddProduct() {
  const expressions = {
    usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
    nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
    password: /^.{4,12}$/, // 4 a 12 digitos.
    email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    numbers: /^[0-9]*$/, // 7 a 14 numeros.
    texto: /^[a-zA-Z0-9 ]{4,500}$/, // Letras
    address: /^[a-zA-Z0-9#, ]{4,500}$/, // Address
  }

  const classes = useStyles();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [productName, setProductName] = useState({ text: '', valid: null });
  const [barcode, setBarcode] = useState({ text: '', valid: null });
  const [description, setDescription] = useState({ text: '', valid: null });
  const [category, setCategory] = useState({ text: '', valid: null });
  const [image, setImage] = useState(null);
  const [cost, setCost] = useState({ text: 0.00, valid: null });
  const [profitCost, setProfitCost] = useState({ text: '', isProfitByPercent: false, valid: null });
  const [priceProduct, setPriceProduct] = useState({ text: 0.00, valid: null });
  const [saleUnit, setSaleUnit] = useState({ text: '', valid: null });
  const [supplier, setSupplier] = useState({ text: '', valid: null });
  const [minStock, setMinStock] = useState({ text: '', valid: null });
  const [note, setNote] = useState({ text: '', valid: null });
  const [isOwnProduct, setIsOwnProduct] = useState(false);

  const [allCategories, setAllCategories] = useState([]);
  const [allSaleUnit, setAllSaleUnit] = useState([]);
  const [allSuppliers, setAllSuppliers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  //const [isOpenModalCamera, openModalCamera, closeModalCamera] = useModal(false);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const fetchCategories = async () => {
    if (!showModal) {
      fetch(baseUrl + "categoryProduct",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.status == null) {
            setAllCategories(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const fetchSaleUnit = async () => {
    if (!showModal) {
      fetch(baseUrl + "saleUnit",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.status == null) {
            setAllSaleUnit(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  const fetchSupplier = async () => {
    if (!showModal) {
      fetch(baseUrl + "supplier",
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          if (data.status == null) {
            setAllSuppliers(data);
          } else {
            setShowModal(true);
          }
        }).catch(error => null);
    }
  }

  useEffect(() => {
    fetchCategories();
    fetchSaleUnit();
    fetchSupplier();
  }, []);

  const calculatePrice = () => {
    if (cost.text != 0.00 && profitCost.text != 0.00) {
      if (profitCost.isProfitByPercent) {
        setPriceProduct({
          text: (parseFloat(cost.text) + (parseFloat(cost.text) * (parseFloat(profitCost.text)).toFixed(0) / 100)).toFixed(2),
          valid: "true"
        });
      } else {
        setPriceProduct({
          text: (parseFloat(cost.text) + parseFloat(profitCost.text)).toFixed(2),
          valid: "true"
        });
      }
    } else {
      setPriceProduct({
        text: cost.text,
        valid: "false"
      });
    }
  }

  const onSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);

    if (productName.valid === 'true' && category.valid === 'true') {
      const formData = new FormData();

      if (image != null) formData.append("file", image);
      formData.append("name", productName.text);
      formData.append("barcode", barcode.text);
      formData.append("description", description.text);
      formData.append("category", category.text);
      formData.append("cost", cost.text);
      formData.append("productProfit", profitCost.text);
      formData.append("isProfitByPercent", profitCost.isProfitByPercent ? 1 : 0);
      formData.append("isOwnProduct", isOwnProduct ? 1 : 0);
      formData.append("salePrice", priceProduct.text);
      formData.append("saleUnit", saleUnit.text);
      formData.append("minStock", minStock.text);
      formData.append("note", note.text);
      formData.append("supplier", supplier.text);

      axios({
        method: "post",
        url: baseUrl + "createProduct",
        data: formData,
        headers: { "Content-Type": "multipart/form-data", 'Authorization': localStorage.getItem("token") },
      })
        .then(function (response) {
          if (response.data.message == "Ok") {
            setProductName({ text: '', valid: null });
            setBarcode({ text: '', valid: null });
            setDescription({ text: '', valid: null });
            setCategory({ text: '', valid: null });
            setImage(null);
            setCost({ text: 0.00, valid: null });
            setProfitCost({ text: '', isProfitByPercent: false, valid: null });
            setPriceProduct({ text: 0.00, valid: null });
            setSaleUnit({ text: '', valid: null });
            setMinStock({ text: '', valid: null });
            setNote({ text: '', valid: null });
            setIsOwnProduct(false);
            setSupplier({ text: '', valid: null });
          } else {
            if (response.data.message == "Access is denied") {
              setShowModal(true);
            }
          }
        })
        .catch(function (response) { });

      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }

  return (
    <div>
      {showModal ? (
        <Modal
          isOpen={showModal}
          closeModal={closeModalLogin}
        />
      ) : (
        <></>
      )}

      <div className={classes.divTitle}>
        <PageTitle title="Alta de producto" />
      </div>

      <div className={classes.divCard} >
        <div className={classes.divThreeColumns} >
          <InputComponent
            text={productName}
            setPartnerCode={setProductName}
            type="text"
            label="Nombre del producto"
            name="productName"
            regularExpression={expressions.texto}
            placeholder="Nombre"
            isRequired={true}
          />

          <InputComponent
            text={barcode}
            setPartnerCode={setBarcode}
            type="text"
            label="Código de barras"
            name="barcode"
            regularExpression={expressions.texto}
            placeholder="Código de barras"
          />

          <InputComponent
            text={description}
            setPartnerCode={setDescription}
            type="text"
            label="Descripción"
            name="description"
            regularExpression={expressions.nombre}
            placeholder="Descripción corta"
          />

          {/*<div>
            <label className={classes.label} >Foto del producto</label>
            <button onClick={openModalCamera}>
              Tomar foto
            </button>
            <ModalCamera
              isOpen={isOpenModalCamera}
              closeModal={closeModalCamera}
              setPhoto={setImage}
            />
          </div>*/}

          <InputSelect
            text={category}
            setValue={setCategory}
            label={"Categoría"}
            options={allCategories}
            isRequired={true}
          />

          <InputSelect
            text={saleUnit}
            setValue={setSaleUnit}
            label={"Unidad de venta"}
            options={allSaleUnit}
            isRequired={true}
          />

          <SwitchOwnProduct
            value={isOwnProduct}
            label={"Producto propio"}
            setValue={setIsOwnProduct}
          />

          <InputDecimalInventory
            text={cost}
            setPartnerCode={setCost}
            type="text"
            label="Costo"
            name="cost"
            placeholder="0.00"
            calculate={calculatePrice}
            isRequired={false}
          />

          <InputProfitProduct
            text={profitCost}
            setPartnerCode={setProfitCost}
            type="text"
            label="Ganancia del producto"
            name="profitProduct"
            placeholder="0.00"
            calculate={calculatePrice}
          />

          <InputDisableSimpleText
            value={priceProduct.text}
            type="text"
            label="Precio de venta"
            name="priceProduct"
            placeholder="0.00"
            isPrice={true}
          />

          <InputComponent
            text={minStock}
            setPartnerCode={setMinStock}
            type="number"
            label="Stock mínimo"
            name="minStock"
            regularExpression={expressions.numbers}
            placeholder="0"
          />

          <InputComponent
            text={note}
            setPartnerCode={setNote}
            type="text"
            label="Nota"
            name="note"
            regularExpression={expressions.nombre}
            placeholder="Nota corta"
          />

          <InputSelect
            text={supplier}
            setValue={setSupplier}
            label={"Proveedor"}
            options={allSuppliers}
            isRequired={true}
          />
        </div>

        <div className={classes.divButton}>
          {isLoading ? (
            <div className={classes.loginLoader} >
              <CircularProgress size={26} />
            </div>

          ) : (
            <button
              className={productName.valid === 'true' && category.valid === 'true' ?
                classes.enableButton : classes.disableButton}
              disabled={!(productName.valid === 'true' && category.valid === 'true')}
              onClick={onSubmit}
            >Agregar</button>
          )}
        </div>
      </div>
    </div>
  );
}
